import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../infrastructure/api.service';
import { MeResponseDto, UpdateMeDto } from './dto/me-response.dto';

@Injectable({ providedIn: 'root' })
export class UserHttpService extends ApiService {
  getMe(): Observable<MeResponseDto> {
    return this.httpClient.get<MeResponseDto>(`${this.env.apiUrl}/users/me`);
  }

  patchMe(body: UpdateMeDto): Observable<MeResponseDto> {
    return this.httpClient.patch<MeResponseDto>(`${this.env.apiUrl}/users/me`, body);
  }
}
